/**
 * 石川県の料理12品。
 *
 * 加賀と能登を半分ずつ。
 * 加賀から五色生菓子・たけのこ昆布・大根ずし・加賀太きゅうり・かぶらずし・じぶ煮・鯛の唐蒸し、
 * 能登からすいぜん・あいまぜ・いしるの貝焼き・メギスのだんご汁、
 * そして香箱ガニ。
 *
 * 輪島塗も九谷焼も美しい器だが、器を描くと絵が器だらけになる。
 * 器を描くのはメギスのだんご汁・いしるの貝焼き・じぶ煮の3つだけにした。
 * 貝焼きはホタテの貝殻がそのまま器になるので、椀や鍋にはしない。
 *
 * 香箱ガニについて。
 *  カニは兵庫・鳥取・福井・佐賀ですでに4県あるが、どれも大きな雄。
 *  石川県公式が「香箱ガニの大きさは雄ガニ（加能ガニ）の半分ほどですが、
 *  甲羅の中にはオレンジ色の未成熟卵の内子やかにミソ、
 *  お腹には茶色の粒状の卵の外子をたっぷりと抱えています」と書いているので、
 *  小ぶりな雌・オレンジの内子・茶色の外子を条件にして、他の4県と絵を分けた。
 *  ただし「甲羅に詰めて盛る」形は公式で確認できなかったので指定していない。
 *  漁期は11月6日から12月29日まで。
 *
 * 他県と重ならないように外したもの。
 *  - ぶり … 富山に割り当てた
 *  - えびす（卵の寒天寄せ） … 富山の「べっこう」と同じもの。富山に置いた
 *  - さざえめし … 島根の「さざえ飯」と同じ名前
 *  - ラーメン・そば・そうめん・和牛 … すでに他県に多い
 *
 * 大根ずしとかぶらずしは、どちらも糀で漬けた発酵食で並べると似る。
 * 大根ずしは薄い大根に飴色の身欠ニシン、かぶらずしは厚い白いかぶに薄紅のブリ。
 * この二点を仕様で言い分けている。
 *
 * 2026-10-02 確定案（audit/_確定案.csv）で料理を入れ替えた。
 * - 外した品：たけのこ昆布・五色生菓子・あいまぜ・すいぜん・大根ずし・加賀太きゅうりのあんかけ・メギスのだんご汁・鯛の唐蒸し（店で食べられる品に差し替え）
 * - 金沢おでん：金沢おでんの始まりの年・発祥の店は、公式資料で確かめられなかったので書かない
 * - ハントンライス：考案した店・シェフの名前は書かない（出典が店名を出しておらず、店の宣伝にもなる）
 * - ハントンライス：発祥の年は出典が「1960年ごろ…などの説」と書くだけなので、「説がある」の形でだけ書いた
 * - 小松うどん：明治期の創業店の名前は出典にあるが、店の宣伝になるので書かない
 * - 小松うどん：「将軍や大名家にも送られた」は出典（つるつる創研）も「とも伝えられる」とする伝承なので、加賀藩に納められたことだけを伝聞形で書いた
 * - 金沢カレー：金沢カレーの元祖の店・始まりの年は、店ごとの主張しか見つからないので書かない
 * - 8番らーめん（野菜らーめん）：創業からの年数・店舗数は変わる数字なので書かない
 * - 8番らーめん（野菜らーめん）：創業地の市町名・創業年は、開いた公式ページ（観光連盟）に書かれていないので書かない。会社の公式サイトは店（チェーン）のサイトなので出典に使わない
 * - 「いしるの貝焼き」を「いしる（いしり）の貝焼き」に改め、絵と説明を描き直した（同じ料理なので ID は ishiru-kaiyaki のまま）。
 * - いしる（いしり）の貝焼き：「日本三大魚醤」は農水省ページに「〜と並ぶ『日本三大魚醤』の一つ」とあり書いてよいが、文字数の都合で入れていない。入れるなら「日本三大魚醤に数えられる」の形で
 * - いしる（いしり）の貝焼き：貝焼きの具（イカ・なすなど）は出典に書かれていないので書かない
 * - 近江町市場の海鮮丼：海鮮丼にのる魚介の種類（甘えび・のどぐろ・白えびなど）は、公式記事では特定の店の紹介としてしか確かめられなかったので書かない
 * - 近江町市場の海鮮丼：市場の歴史（2021年に開場300年、藩政時代から約300年、1721年から加賀藩前田家の御膳所）は公式ページにあるが、字数の都合で入れていない。使うなら source の「2021年に開場300年」か、近江町市場振興組合の「藩政時代から約300年」
 * - 品名「能登丼（能登牛の丼）」を「能登丼」に地元で通じる呼び名に改めた（2026-10-11 地元民レビュー。同じ料理なので ID はそのまま）。能登丼は能登牛に限らない丼の総称のため
 * - 能登丼（能登牛の丼）：「奥能登4市町（輪島市・珠洲市・穴水町・能登町）」は開いた公式ページで確かめられなかったので、地域は「奥能登」とだけ書いた
 * - 能登丼（能登牛の丼）：店の能登牛丼の品名・値段は書かない
 * - のどぐろの塩焼き：「ムツ」は阿波弁で脂っこいことを表す、という名の由来：出典に「考えられる」とある推測なので書かない
 * - のどぐろの塩焼き：旬の体脂肪率（20%超）：出典は「といわれる」という伝聞なので書かない
 * - のどぐろの塩焼き：値段が張る・金沢の飲食店では高めといった値段の話：すぐ変わる情報なので書かない
 * - のどぐろの塩焼き：レモン・大根おろしを添える食べ方：公式資料で確かめられなかったので書かない（絵には描いてある）
 */

import { attachHulls } from '../../utils/itemShape';
import type { RewardLink, StageDefinition, StageItemDefinition } from '../types';
import { ishikawaSceneryTour } from './ishikawaScenes';
import { ISHIKAWA_FOOD_HULLS } from './ishikawaFoodShapes.generated';

function searchLinks(area: string, dish: string): RewardLink[] {
  return [
    {
      label: '地図で探す',
      url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${area} ${dish}`)}`,
    },
    {
      label: 'お店を調べる',
      url: `https://www.google.com/search?q=${encodeURIComponent(`${area} ${dish}`)}`,
    },
  ];
}

const FOOD_ITEMS: StageItemDefinition[] = [
  {
    id: 'kabura-zushi',
    level: 1,
    name: 'かぶらずし',
    shortName: 'かぶらずし',
    image: '/assets/foods/ishikawa/01_kabura_zushi.webp',
    radius: 17,
    mass: 1,
    score: 2,
    description: '厚いかぶに切れ目を入れ、ブリを挟む。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/kaburazushi_ishikawa.html',
    icon: { label: 'かぶらずし', shape: 'sashimi-platter', baseColor: '#f4f0ec', accentColor: '#e09098' },
    reward: {
      unlockScore: 200,
      area: '金沢市',
      headline: '塩漬けにした厚い輪切りのかぶに塩漬けのブリを挟み、糀と甘酒で漬けた石川を代表する発酵食。',
      tip: '金沢市金石町の漁師が豊漁祈願・安全祈願で正月の行事食として食べはじめたという説がある。少なくとも江戸時代には食べられていたという。「ブリ一本、米一俵」といわれるほどの高級食材で、かぶらずしがないと正月が始まらないという地元の人もいる。ブリをようかんのように切って四十日ほど塩漬けにし、かぶらに挟んで七日から十日で漬け上がる。',
      links: searchLinks('金沢市', 'かぶらずし'),
    },
  },
  {
    id: 'kanazawa-oden',
    level: 2,
    name: '金沢おでん',
    shortName: '金沢おでん',
    image: '/assets/foods/ishikawa/02_kanazawa_oden.webp',
    radius: 21,
    mass: 1.3,
    score: 4,
    description: '昆布と鰹節のうまみが効いた、醤油ベースの澄んだ出汁が特徴。車麩、赤巻、ふかし、バイ貝など金沢ならではの具を使う。一年中食べられ、冬はカニ面も加わる。',
    source:
      'https://www.hot-ishikawa.jp/feature/detail_506.html',
    icon: { label: 'おでん', shape: 'pot', baseColor: '#c9954a', accentColor: '#7a4a22' },
    reward: {
      unlockScore: 500,
      area: '金沢市',
      headline: '澄んだ出汁に車麩とバイ貝',
      tip: '具には加賀野菜の源助大根も使われる。おでん専門店のほか、寒くなると多くの居酒屋でも食べられる。創業の古い店が集まる「金沢おでん老舗50年会」がある。',
      links: searchLinks('金沢市', '金沢おでん'),
      official: [{ label: '金沢市観光協会「金沢おでんが食べられるお店 エリア別リスト」', url: 'https://www.kanazawa-kankoukyoukai.or.jp/article/detail_490.html' }],
    },
  },
  {
    id: 'hanton-rice',
    level: 3,
    name: 'ハントンライス',
    shortName: 'ハントンライス',
    image: '/assets/foods/ishikawa/03_hanton_rice.webp',
    radius: 26,
    mass: 1.7,
    score: 8,
    description: '金沢市生まれの洋食。半熟の卵の上に白身魚やエビのフライをのせ、ケチャップとタルタルソースをかける。見た目はオムライスに似ている。',
    source:
      'https://www.hot-ishikawa.jp/feature/detail_506.html',
    icon: { label: 'ハントン', shape: 'curry-plate', baseColor: '#f2c94c', accentColor: '#d64532' },
    reward: {
      unlockScore: 1000,
      area: '金沢市',
      headline: '卵の上にフライと二色のソース',
      tip: '名前はハンガリーの「ハン」と、フランス語でマグロを意味する「トン」を合わせた造語とされる。1960年ごろ金沢のレストランのまかないとして生まれたという説がある。',
      links: searchLinks('金沢市', 'ハントンライス'),
      official: [{ label: 'ほっと石川旅ねっと「ハントンライスとは？金沢名物の由来と人気店5選」', url: 'https://www.hot-ishikawa.jp/blog/detail_583.html' }],
    },
  },
  {
    id: 'komatsu-udon',
    level: 4,
    name: '小松うどん',
    shortName: '小松うどん',
    image: '/assets/foods/ishikawa/04_komatsu_udon.webp',
    radius: 30,
    mass: 2.2,
    score: 16,
    description: '細めで程よいコシのある麺を、ウルメ、ムロアジ、サバなどの雑節と昆布を使ったあっさりした出汁で食べる。麺は白山の伏流水を使って作る。',
    source:
      'https://www.komatsuguide.jp/feature/detail_181.html',
    icon: { label: 'うどん', shape: 'noodle-bowl', baseColor: '#f3ead2', accentColor: '#e58aa0' },
    reward: {
      unlockScore: 1800,
      area: '小松市',
      headline: '白山の水で作る細めのうどん',
      tip: '松尾芭蕉は奥の細道の旅で小松を訪れたとき、地元の俳人から乾うどんを贈られ、礼状を残したと伝わる。加賀藩に納められていたとも伝えられる。',
      links: searchLinks('小松市', '小松うどん'),
      official: [{ label: 'NPO法人 小松うどんつるつる創研', url: 'https://komatsu-udon.com/' }],
    },
  },
  {
    id: 'kanazawa-curry',
    level: 5,
    name: '金沢カレー',
    shortName: '金沢カレー',
    image: '/assets/foods/ishikawa/05_kanazawa_curry.webp',
    radius: 36,
    mass: 2.8,
    score: 32,
    description: '濃厚でドロッとしたルーに、キャベツの千切りを添える。ルーの上にカツをのせ、カツにはソースをかける。ステンレスの皿に盛るのが決まり。',
    source:
      'https://kanazawacurry-kyokai.com/',
    icon: { label: 'カレー', shape: 'curry-plate', baseColor: '#3b2414', accentColor: '#a8c97a' },
    reward: {
      unlockScore: 3000,
      area: '金沢市',
      headline: '黒く濃いルーにカツとキャベツ',
      tip: 'フォークか先割れスプーンで食べるのも、金沢カレー協会が挙げる特徴のひとつ。協会は金沢カレーの知名度を保ち高めようとする企業や団体でつくられている。',
      links: searchLinks('金沢市', '金沢カレー'),
      official: [{ label: 'ほっと石川旅ねっと「石川・金沢のご当地グルメ」7選', url: 'https://www.hot-ishikawa.jp/feature/detail_506.html' }],
    },
  },
  {
    id: 'hachiban-yasai-ramen',
    level: 6,
    name: '8番らーめん（野菜らーめん）',
    shortName: '8番らーめん',
    image: '/assets/foods/ishikawa/06_hachiban_yasai_ramen.webp',
    radius: 42,
    mass: 3.5,
    score: 64,
    description: '石川県生まれのラーメンチェーンの看板メニュー。キャベツを主に、玉ねぎ、もやし、にんじんを店で大きな中華鍋で炒め、麺の上にたっぷり盛る。スープは豚骨がベースで、野菜を煮込んでうまみを移す。',
    source:
      'https://www.hot-ishikawa.jp/feature/detail_298.html',
    icon: { label: '野菜ラーメン', shape: 'ramen', baseColor: '#e8dcc0', accentColor: '#6fae4a' },
    reward: {
      unlockScore: 4500,
      area: '石川県',
      headline: '中華鍋で炒めた野菜をたっぷり',
      tip: '「8」の字のかまぼこがのるのが目じるし。石川県民にはご当地ラーメンの筆頭として親しまれている。',
      links: searchLinks('金沢市', '8番らーめん 野菜らーめん'),
    },
  },
  {
    id: 'ishiru-kaiyaki',
    level: 7,
    name: 'いしる（いしり）の貝焼き',
    shortName: 'いしるの貝焼き',
    image: '/assets/foods/ishikawa/07_ishiru_kaiyaki.webp',
    radius: 46,
    mass: 4.4,
    score: 128,
    description: '能登の魚醤いしるで魚介や野菜を煮る食べ方のひとつで、ホタテの貝殻を鍋の代わりに使う。北海道と大阪を結んだ北前船がもたらした食べ方とされる。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/ishirunabe_ishikawa.html',
    icon: { label: '貝焼き', shape: 'hotpot', baseColor: '#e9d3a8', accentColor: '#a8622a' },
    reward: {
      unlockScore: 6500,
      area: '能登地方',
      headline: 'ホタテの殻を鍋にする',
      tip: 'いしるは主にスルメイカの内臓から作り、地域によってはイワシやサバ、アジも使う。「魚汁」がなまった名とされ、「いしり」「よしる」と呼ぶ地域もある。',
      links: searchLinks('能登', 'いしるの貝焼き'),
    },
  },
  {
    id: 'jibuni',
    level: 8,
    name: 'じぶ煮',
    shortName: 'じぶ煮',
    image: '/assets/foods/ishikawa/08_jibuni.webp',
    radius: 51,
    mass: 5.4,
    score: 256,
    description: '小麦粉をまぶして煮ると、汁にとろみがつく。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/jibuni_ishikawa.html',
    icon: { label: 'じぶ煮', shape: 'rice-bowl', baseColor: '#6a4a28', accentColor: '#7aa03a' },
    reward: {
      unlockScore: 9000,
      area: '金沢市',
      headline: '小麦粉をまぶした鴨肉とすだれ麩を煮て、わさびを天盛りにした石川を代表する煮物。',
      tip: '少なくとも江戸時代から食べられていた武家料理。発祥はキリシタン大名の高山右近が宣教師から教わって加賀藩に伝えた説、岡部治部右衛門が朝鮮から伝えた説、漂流したロシア人が伝えた説などがある。名も岡部治部右衛門の治部説や、じぶじぶ煮るという擬声語に由来する説がある。たっぷりの小麦粉をまぶして煮ることで肉の旨味をとじこめ、汁にとろみがつく。',
      links: searchLinks('金沢市', '治部煮'),
    },
  },
  {
    id: 'omicho-kaisendon',
    level: 9,
    name: '近江町市場の海鮮丼',
    shortName: '近江町の海鮮丼',
    image: '/assets/foods/ishikawa/09_omicho_kaisendon.webp',
    radius: 57,
    mass: 6.6,
    score: 512,
    description: '金沢の近江町市場の名物。市場には日本海の魚介を使った海鮮丼や寿司の店が多く、朝とれた新鮮な魚介を使った海鮮丼を、店ごとにさまざまな組み合わせで出している。',
    source:
      'https://www.kanazawa-kankoukyoukai.or.jp/omicho',
    icon: { label: '海鮮丼', shape: 'sashimi-platter', baseColor: '#d9433a', accentColor: '#f29b38' },
    reward: {
      unlockScore: 12000,
      area: '金沢市（近江町市場）',
      headline: '市民の台所でとれたての丼',
      tip: '近江町市場は「市民の台所」と呼ばれ、約170の店が並ぶ。市民だけでなく、料亭や飲食店の料理人も仕入れに訪れる。',
      links: searchLinks('金沢市 近江町市場', '海鮮丼'),
      official: [{ label: '近江町市場（近江町市場振興組合）', url: 'https://ohmicho-ichiba.com/' }],
    },
  },
  {
    id: 'noto-don',
    level: 10,
    name: '能登丼',
    shortName: '能登丼',
    image: '/assets/foods/ishikawa/10_noto_don.webp',
    radius: 63,
    mass: 8,
    score: 1024,
    description: '奥能登産の米と水を使い、地元でとれた旬の魚介や、能登で育てた肉・野菜、伝統の保存食を主な具にする丼。能登産の器と箸で出し、箸は客に贈られる。能登牛をのせた丼もある。',
    source:
      'https://www.okunoto-ishikawa.net/modules/donmap/',
    icon: { label: '能登丼', shape: 'rice-bowl', baseColor: '#9b4a2e', accentColor: '#e8c27a' },
    reward: {
      unlockScore: 16000,
      area: '奥能登',
      headline: '奥能登の米と水で作る丼',
      tip: '2007年の能登半島地震をきっかけに始まった。いまは令和6年能登半島地震の影響で休業や提供休止の店もある。',
      links: searchLinks('能登町', '能登丼 能登牛'),
      official: [{ label: 'うぇるかむ奥能登「能登丼 店舗一覧」', url: 'https://www.okunoto-ishikawa.net/modules/donmap/index.php?page=shop_status' }],
    },
  },
  {
    id: 'nodoguro-shioyaki',
    level: 11,
    name: 'のどぐろの塩焼き',
    shortName: 'のどぐろの塩焼き',
    image: '/assets/foods/ishikawa/11_nodoguro_shioyaki.webp',
    radius: 70,
    mass: 9.6,
    score: 2048,
    description: '一般的な名称はアカムツ。口の奥が黒いことから、日本海側ではノドグロと呼ばれる。脂は身だけでなく皮と身の間にもたっぷりあり、「白身のトロ」の異名を持つ。中でも人気があるのが塩焼きだ。',
    source:
      'https://www4.city.kanazawa.lg.jp/material/files/group/33/45nodoguro.pdf',
    icon: { label: 'のどぐろ', shape: 'fish', baseColor: '#d9532f', accentColor: '#e8e4dc' },
    reward: {
      unlockScore: 22000,
      area: '金沢市／能登地方',
      headline: '「白身のトロ」と呼ばれる赤い魚',
      tip: '通年水揚げされるが、特に秋から冬が旬。石川県では能登が産地として知られる。漁獲量が少なく、あまり流通しない魚とされる。',
      links: searchLinks('金沢市', 'のどぐろ 塩焼き'),
      official: [{ label: 'JFいしかわ輪島支所「輪島 ノドクロ」', url: 'https://www.ikwajimagyokyo.jp/brand/nodokuro.html' }],
    },
  },
  {
    id: 'koubako-gani',
    level: 12,
    name: '香箱ガニ',
    shortName: '香箱ガニ',
    image: '/assets/foods/ishikawa/12_koubako_gani.webp',
    radius: 78,
    mass: 11.4,
    score: 4096,
    description: '甲羅にオレンジ、腹に茶色の卵を抱く。',
    source:
      'https://www.pref.ishikawa.lg.jp/nousei/brand/hyakumngokunokiwami.html',
    icon: { label: '香箱ガニ', shape: 'feast', baseColor: '#c85030', accentColor: '#e88030' },
    reward: {
      unlockScore: 30000,
      area: '金沢市',
      headline: '雄の半分ほどの大きさで、甲羅にオレンジの内子、腹に茶色の外子をたっぷり抱えた石川の雌ガニ。',
      tip: '石川県公式は「香箱ガニの大きさは雄ガニ（加能ガニ）の半分ほどですが、甲羅の中にはオレンジ色の未成熟卵の内子やかにミソ、お腹には茶色の粒状の卵の外子をたっぷりと抱えています」と紹介している。石川県では毎年11月6日がカニ漁の解禁日で、雄の加能ガニは3月20日まで、雌の香箱ガニは資源保護のため12月29日までと漁期が短い。',
      links: searchLinks('金沢市', '香箱ガニ'),
    },
  },
];

/** 得点は 2 ^ level を基準にしている（GAME_TUNING.score で方式変更可能）。 */
export const ishikawaFoodStage: StageDefinition = {
  regionId: 'ishikawa',
  regionName: '石川県',
  mode: 'food',
  title: '石川めしマージ',
  theme: {
    primaryColor: '#7a2838',
    secondaryColor: '#c8a038',
    accentColor: '#e8cc78',
    backgroundColor: '#12100e',
  },
  /** 背景ツアー「石川めぐり」。軸は一日の時間。朝の千里浜から、冬の夕暮れの兼六園へ。 */
  scenery: {
    tour: ishikawaSceneryTour,
  },
  items: attachHulls(FOOD_ITEMS, ISHIKAWA_FOOD_HULLS),
};
